import { inject, Injectable } from '@angular/core';
import {
  groupOrderItemsByStatus,
  isOneOfDeliveryStatuses,
  mapDtoToInternalOrder,
  OrderDetails,
  OrderDetailsDTO,
  OrderDetailsWithGroupedLineItems,
  OrderHistoryTableItem,
  OrderLineItem,
  Paginated,
  PSEUDO_ITEM_STATUSES,
} from '@models';
import { map, Observable } from 'rxjs';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class AccountDataServiceService {
  private readonly apiService = inject(ApiService);

  getOrdersList(
    page: number,
    pageSize: number,
    status?: string,
    placedAfter?: string,
    skipCount = 0,
  ): Observable<Paginated<OrderHistoryTableItem>> {
    const params = {
      page,
      pageSize,
      skipCount,
      status,
      placedAfter,
    };
    return this.apiService.get('orders', params);
  }

  getOrderDetailsRequest<T = OrderDetailsDTO>(orderId: string | number): Observable<T> {
    return this.apiService.get<T>(`orders/${orderId}`);
  }

  getOrderDetails(orderId: string | number): Observable<OrderDetailsWithGroupedLineItems> {
    return this.getOrderDetailsRequest(orderId).pipe(
      map(mapDtoToInternalOrder),
      map(populateOrderDetailsWithPseudoItems),
      map(groupOrderItemsByStatus),
    );
  }
}

function populateOrderDetailsWithPseudoItems(order: OrderDetails, index: number): OrderDetails {
  const deliveryPipelineItems: OrderLineItem[] = [];
  const orderRejectionItems: OrderLineItem[] = [];

  order.lineItems.forEach((product) => {
    const statusForPseudoItem = PSEUDO_ITEM_STATUSES[product.status];
    if (statusForPseudoItem) {
      orderRejectionItems.push(product);
      deliveryPipelineItems.push({
        ...product,
        status: statusForPseudoItem,
      });
    }

    if (isOneOfDeliveryStatuses(product.status)) {
      deliveryPipelineItems.push(product);
    }
  });

  return { ...order, lineItems: [...deliveryPipelineItems, ...orderRejectionItems] };
}
